export default __webpack_public_path__ + "static/media/nafha2.2944e04b.jpg";